import { commonConfig } from "~/config/common-config";

export const isRelativeUrl = (url: string): boolean =>
  !url.startsWith("http") || url.startsWith(commonConfig.NEXT_PUBLIC_ENDIL_URL);
